import { AlertService } from "app/services";
import { SalesService, UserForSalesManagement } from "app/services/sales.service";

export class MailFormComponentViewModel {
  isOpen: boolean = false;
  isSmall: boolean = false;
  to: string;
  cc: string;
  subject: string;
  content: string;
  file: File = null;
  user: UserForSalesManagement;

  ckEditorConfig = {
    // extraPlugins: 'divarea',
    height: -1,
    toolbar: [
      // { name: 'document', groups: [ 'mode', 'document', 'doctools' ], items: [ 'Source', '-', 'Save', 'NewPage', 'ExportPdf', 'Preview', 'Print', '-', 'Templates' ] },
      // { name: 'clipboard', groups: [ 'clipboard', 'undo' ], items: [ 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo' ] },
      // { name: 'editing', groups: [ 'find', 'selection', 'spellchecker' ], items: [ 'Find', 'Replace', '-', 'SelectAll', '-', 'Scayt' ] },
      // { name: 'forms', items: [ 'Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField' ] },
      // '/',
      // { name: 'links', items: [ 'Link', 'Unlink', 'Anchor' ] },
      // { name: 'insert', items: [ 'Image', 'Flash', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe' ] },
      // '/',
      { name: 'styles', items: [ 'Styles', 'Format', 'Font', 'FontSize' ] },
      { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ], items: [ 'Bold', 'Italic', 'Underline', 'Strike'] },
      { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi' ], items: [ 'NumberedList', 'BulletedList', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
      { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
      // { name: 'tools', items: [ 'Maximize', 'ShowBlocks' ] },
      // { name: 'others', items: [ '-' ] },
      // { name: 'about', items: [ 'About' ] }
    ],

  };

  constructor(private salesService:SalesService, private alertService: AlertService){
  }

  open(user: UserForSalesManagement) {
    this.isSmall = false;
    this.user = user;
    this.to = String(this.user.email);
    this.cc = null;
    this.file = null;
    this.isOpen = true;
    this.isSmall = false;
  }

  close() {
    this.isOpen = false;    
  }

  toggleSize() {
    this.isSmall = !this.isSmall;    
  }

  stopPropagation(event: UIEvent) {
    event.stopPropagation();
  }

  send() {
    let session = JSON.parse(localStorage.getItem('currentUser'));
    let from = session.username;
    let senderId = String(session.id);

    if (!this.user) {
      this.alertService.error('선택 사용자가 존재하지 않습니다.');
      return;
    }

    if (!this.subject || this.subject.trim().length <= 0) {
      this.alertService.error('제목은 필수 항목입니다.');
      return;
    }

    let salesStatusCode: string = null;
    if (this.user.salesStatusDetail && this.user.salesStatusDetail.salesStatusCode) {
      salesStatusCode = String(this.user.salesStatusDetail.salesStatusCode);
    }

    let salesManagerUserId: string = null;
    if (this.user.salesManager && this.user.salesManager.userId) {
      salesManagerUserId = String(this.user.salesManager.userId);
    }

    const formData = new FormData();
    formData.append('userId', String(this.user.userId));
    formData.append('senderId', senderId);
    formData.append('salesStatusCode', salesStatusCode);
    formData.append('salesManagerUserId', salesManagerUserId);
    formData.append('subject', this.subject);
    formData.append('content', this.content);
    formData.append('contentType', 'HTML');
    
    formData.append('from', from);
    formData.append('to', this.to);
    formData.append('cc', this.cc);

    
    formData.append('file', this.file);

    this.salesService.sendEmail(
      formData,
      () => {
        this.alertService.success('메일이 전송 되었습니다.');
        this.close();
      },
      (error) => {
        this.alertService.error(error);
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/user/modal/mail-form.viewmodel.ts